var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQMFactCy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "uuid-a7c51b73-f971-4945-8843-19ae74259f8d",
    viewBox: "0 0 90.7 90.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.35,85.7c-22.25,0-40.35-18.1-40.35-40.35S23.1,5,45.35,5s40.35,18.1,40.35,40.35-18.1,40.35-40.35,40.35ZM45.35,9.76c-19.62,0-35.59,15.97-35.59,35.59s15.97,35.59,35.59,35.59,35.59-15.97,35.59-35.59S64.97,9.76,45.35,9.76Z",
    fill: "#ff9a00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.33,25.38h-19.97c-3.3,0-5.99,2.69-5.99,5.99v31.95c0,.74.41,1.41,1.06,1.76.65.35,1.44.31,2.05-.1l4.63-3.09,2.84,2.84c.78.78,2.04.78,2.82,0l2.58-2.58,2.58,2.58c.39.39.9.59,1.41.59s1.02-.2,1.41-.59l2.84-2.84,4.63,3.09c.61.41,1.4.45,2.05.1.65-.35,1.06-1.02,1.06-1.76v-31.95c0-3.3-2.69-5.99-5.99-5.99ZM47.34,53.34h-7.99c-1.1,0-2-.89-2-2s.89-2,2-2h7.99c1.1,0,2,.89,2,2s-.89,2-2,2ZM51.34,45.35h-11.98c-1.1,0-2-.89-2-2s.89-2,2-2h11.98c1.1,0,2,.89,2,2s-.89,2-2,2ZM51.34,37.36h-11.98c-1.1,0-2-.89-2-2s.89-2,2-2h11.98c1.1,0,2,.89,2,2s-.89,2-2,2Z",
    fill: "#ff9a00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQMFactCy);
export default __webpack_public_path__ + "static/media/q_M-FACT-CY.6fdeb531ee9a0117c527ec36ab3694e7.svg";
export { ForwardRef as ReactComponent };